export enum SceneryElementType {
  Wall = 'wall',
  CadDoor = 'cad-door',
  CadObject = 'cad-object',
}
